var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('action-button'),_vm._v(" "),_c('div',{attrs:{"id":"map"}}),_vm._v(" "),_c('mapbox',{attrs:{"access-token":"","map-options":{
      style: {
        glyphs: 'https://dvn3ptw8fp74t.cloudfront.net/{fontstack}/{range}.pbf',
        version: 8,
        sources: {
          'osm-tiles': {
            type: 'raster',
            tiles: [
            'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png',
            'https://b.tile.openstreetmap.org/{z}/{x}/{y}.png'
            ],
            tileSize: 256
          },
          'marker-layer-source': {
            type: 'geojson',
            data: {
                'type': 'FeatureCollection',
                'features': [{
                    'type': 'Feature',
                    'properties': {},
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -76.53063297271729,
                            39.18174077994108
                        ]
                    }
                }]
            }
          }
        },
        layers: [{
          id: 'osm-tiles',
          type: 'raster',
          source: 'osm-tiles',
          minzoom: 0,
          maxzoom: 22
        },{
          id: 'marker-layer-bottom',
          type: 'circle',
          source: 'marker-layer-source'
        },{
          id: 'marker-layer-polygons',
          type: 'circle',
          source: 'marker-layer-source'
        },{
          id: 'marker-layer-labels',
          type: 'circle',
          source: 'marker-layer-source'
        }]
      },
      center: [-122.937613, 50.099706],
      zoom: 12,
      bearing: 150
    },"geolocate-control":{
      show: true, 
      position: 'top-right'
    }},on:{"map-load":_vm.mapLoaded,"map-init":_vm.mapInitialized}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0f1d1c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mapComponent.vue
// module id = 49
// module chunks = 1